// config/tipos.ts
import { Area, Point } from "react-easy-crop";

// ==========================================
// UPLOADTHING TYPES
// ==========================================

export interface FileEntry {
  id: string;
  customId?: string;
  key: string;
  name: string;
  status: string;
  size: number;
  uploadedAt: number;
}

export interface UploadthingListResponse {
  hasMore: boolean;
  files: FileEntry[];
}

export interface UploadResponse {
  key: string | null;
}

export interface StatusResponse {
  status: string;
  fileData: {
    fileUrl: string;
  };
}

export interface UploadthingDeleteResponse {
  success: boolean;
  message?: string;
}

// ==========================================
// AVATAR COMPONENT TYPES
// ==========================================

export interface AvatarComponentProps {
  username?: string;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  showSkeleton?: boolean;
  fallbackBg?: string;
}

export const sizeClasses = {
  sm: "w-8 h-8 text-xs",
  md: "w-12 h-12 text-sm",
  lg: "w-24 h-24 text-lg",
  xl: "w-32 h-32 text-xl",
} as const;

// ==========================================
// CROPPER TYPES
// ==========================================

export interface CropperUIProps {
  image: string;
  crop: Point;
  zoom: number;
  onCropChange: (point: Point) => void;
  onZoomChange: (zoom: number) => void;
  onCropComplete: (croppedArea: Area, croppedPixels: Area) => void;
}

export interface AvatarCropDialogProps {
  onConfirm: (fileUrl: string) => void;
  // Removendo props desnecessárias - o componente pode pegar do getUser()
}

// ==========================================
// UTILITY TYPES
// ==========================================

export interface FileValidationResult {
  isValid: boolean;
  error?: string;
}

export interface UserAvatarState {
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  fileUrl: string | null;
  refetchFileKey: () => void;
  refetchStatus: () => void;
}
